import React from 'react';
import { motion } from 'framer-motion';
interface ContentSectionProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
}
export function ContentSection({
  children,
  className = '',
  delay = 0
}: ContentSectionProps) {
  return <motion.section initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.6,
    delay
  }} className={`mb-12 ${className}`} data-id="element-12">
      {children}
    </motion.section>;
}